module.exports = __webpack_public_path__ + "img/logo-autoscout.ac138723.svg";